'use client';

export { default } from './TableSortLabel';
export { default as tableSortLabelClasses } from './tableSortLabelClasses';
export * from './tableSortLabelClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/TableSortLabel/index.js
// module id = 972
// module chunks = 25